'use strict';

const HomeyAPIV3 = require('./HomeyAPIV3');


/**
 * This class is returned by {@link AthomCloudAPI.Homey#authenticate} for a Homey with `platform: 'cloud'` and `platformVersion: 1`.
 *
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3
 */
class HomeyAPIV3Cloud extends HomeyAPIV3 {

  /**
   * Possible Discovery Strategies
   * @static
   * @property {object} DISCOVERY_STRATEGIES
   * @property {string} DISCOVERY_STRATEGIES.CLOUD - Cloud HTTPS, e.g. `https://abcdef.connect.athom.com`.
   */
  static DISCOVERY_STRATEGIES = {
    CLOUD: 'cloud',
  };

  constructor({
    strategy = [
      HomeyAPIV3Cloud.DISCOVERY_STRATEGIES.CLOUD,
    ],
    ...props
  }) {
    super({
      strategy,
      ...props,
    });
  }

  get tier() {
    return this.__tierCache[this.id];
  }

  get version() {
    return this.__versionCache[this.id];
  }

  get platform() {
    return 'cloud';
  }

  get platformVersion() {
    return 1;
  }

  getSpecification() {
    return require('../../assets/specifications/HomeyAPIV3Cloud.json');
  }

}

module.exports = HomeyAPIV3Cloud;
